var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpened = function SvgOpened(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".opened_svg__b{fill:transparent;stroke:#babcff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.2px}"))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "opened_svg__b",
    d: "M16.945 6.326a2.724 2.724 0 0 1 1.169 2.235v8.663h0a1.067 1.067 0 0 1-1.067 1.067H2.955a1.067 1.067 0 0 1-1.067-1.067V8.561a2.723 2.723 0 0 1 1.168-2.235l5.918-4.114a1.8 1.8 0 0 1 2.053 0ZM18.109 8.68 2.126 17.879M9.927 13.121 2.039 8.438"
  })));
};
export default SvgOpened;